import React from "react";
import "./App.css";
import Gallery from "./components/Gallery";
import Resume from "./components/Resume";
import Intro from "./components/Intro";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { ParallaxProvider } from "react-scroll-parallax";

function App() {
  return (
    <>
      <ParallaxProvider>
        <Intro />
        <Resume />
        <Gallery />
        <Contact/>
        <Footer/>
      </ParallaxProvider>
    </>
  );
}

export default App;
